export const FORM_FIELDS = {
   SRC: 'videoUrl',
   WIDTH: 'videoWidth',
   HEIGHT: 'videoHeight',
} as const;